module.exports = __webpack_public_path__ + "linea-arrows-10.9b287297a8d930c35c32.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-arrows-10.eot
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-arrows-10.eot
// module chunks = styles